import * as Yup from 'yup';
import { DictionaryDirpArea } from './../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryDirpArea>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
